#import "../../../../../graphql/fragments/peep-legacy-id-fragment.graphql"

query GetContactLegacyId($contactId: ID!) {
    contact(id: $contactId) {
        ...PeepLegacyIdFragment
    }
}
